import React from 'react';
import { Box, Inline } from '@atlaskit/primitives/compiled';
import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';
import UFOSegment from '@atlassian/jira-ufo-segment';
import type { ProjectRecommendation } from './types.tsx';
import RecommendedProjectCard from './RecommendedProjectCard.tsx';
import { RecommendedProjectsEmptyState } from './RecommendedProjectsEmptyState.tsx';

export type RecommendedProjectSectionProps = {
	recommendations: ProjectRecommendation[];
	title?: string;
};

const styles = cssMap({
	sectionStyles: {
		overflowX: 'auto',
		paddingTop: token('space.250'),
		paddingBottom: token('space.250'),
		position: 'relative',
		flexDirection: 'column',
	},
	projectsListStyles: {},
});

const RecommendedProjectsSection = ({
	recommendations,
}: RecommendedProjectSectionProps): React.ReactElement => {
	if (!recommendations || recommendations.length === 0) {
		return <RecommendedProjectsEmptyState />;
	}

	return (
		<UFOSegment name="recommendedProjectsSection">
			<Box xcss={styles.sectionStyles}>
				<Inline space="space.100" xcss={styles.projectsListStyles} as="div">
					{recommendations.map((recommendation) => (
						<RecommendedProjectCard
							key={recommendation.project.key}
							recommendation={recommendation}
						/>
					))}
				</Inline>
			</Box>
		</UFOSegment>
	);
};

export default RecommendedProjectsSection;
